import React from 'react';
import { dashboardMenu, demoPages, extraMenu, layoutMenu } from '../menu';
import Footer from '../layout/Footer/Footer';

const footers = [
	/* //프로필
	{ path: extraMenu.profile.path, element: null, exact: true },
	//DC관리
	{ path: dashboardMenu.DCManagement.subMenu.userManagement.path, element: null, exact: true },
	{
		path: dashboardMenu.DCManagement.subMenu.tempUserManagement.path,
		element: null,
		exact: true,
	},
	{
		path: dashboardMenu.DCManagement.subMenu.systemAuthorityManagement.path,
		element: null,
		exact: true,
	},
	{
		path: dashboardMenu.DCManagement.subMenu.partCompManagement.path,
		element: null,
		exact: true,
	},
	//권한관리
	{ path: dashboardMenu.authManagement.subMenu.authInquiry.path, element: null, exact: true },
	{
		path: dashboardMenu.authManagement.subMenu.authMenuManagement.path,
		element: null,
		exact: true,
	},
	{
		path: dashboardMenu.authManagement.subMenu.authUserManagement.path,
		element: null,
		exact: true,
	},
	//
	{ path: layoutMenu.blank.path, element: null, exact: true },
	{ path: demoPages.login.path, element: null, exact: true },
	{ path: demoPages.signUp.path, element: null, exact: true },
	{ path: demoPages.page404.path, element: null, exact: true },
	{ path: demoPages.knowledge.subMenu.grid.path, element: null, exact: true }, */
	{ path: '*', element: null },
];

export default footers;
